import { Dialog, DialogTitle, Grid, FormControl, InputLabel, MenuItem, Select, Stack, Button } from '@mui/material';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { useState } from 'react';

const ProviderFacilityDialog = (props) => {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(11);
    return (
        <Dialog open={props.open} onClose={props.onClose} fullWidth disableEnforceFocus maxWidth="xl">
            <Grid container p={3} spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <DialogTitle>ADD {props.selectTitle.toUpperCase()}</DialogTitle>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Stack direction="row" justifyContent="flex-end" spacing={2}>
                        <Button
                            disabled={props.selectionModel.length === 0}
                            sx={{ minWidth: '120px' }}
                            variant="contained"
                            onClick={(e) => {
                                props.assignProviderHandler(e);
                            }}
                        >
                            Assign {props.selectTitle}
                        </Button>
                        <Button
                            sx={{ minWidth: '120px' }}
                            variant="outlined"
                            onClick={(e) => {
                                props.onClose(e);
                            }}
                        >
                            Cancel
                        </Button>
                    </Stack>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">{props.selectLabel}</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue={'-1'}
                            value={props.selectValue}
                            label={props.selectLabel}
                            onChange={props.selectOnChange}
                        >
                            <MenuItem value={'-1'}>All</MenuItem>
                            {props.selectOptions}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <div style={{ height: '60vh', width: '100%' }}>
                        <DataGrid
                            rows={props.rows}
                            columns={props.columns}
                            pageSizeOptions={[5]}
                            paginationModel={{ pageSize: pageSize, page: page }}
                            onPaginationModelChange={(model) => {
                                setPageSize(model.pageSize);
                                setPage(model.page);
                            }}
                            getRowId={(row) => row.Id || row.ProviderId}
                            columnVisibilityModel={props.columnVisibilityModel}
                            checkboxSelection
                            onRowSelectionModelChange={props.selectionModelHandler}
                            rowSelectionModel={props.selectionModel}
                            getRowHeight={() => 'auto'}
                            sx={{
                                [`& .${gridClasses.cell}`]: {
                                    py: 1,
                                },
                                [`& .MuiDataGrid-columnHeaderTitleContainerContent .MuiCheckbox-root`]: {
                                    display: 'none',
                                },
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </Dialog>
    );
};

export default ProviderFacilityDialog;
